export default "__VITE_ASSET__BOQ23fS7__"